import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { closeStaffModal } from "../../redux/features/staffModalSlice";
import { addStaff } from "../../redux/services/Staff Services/Staff.Services";
// import { getRoleList } from "../../redux/services/RoleService/role.Services"
import { allActiveRole } from "../../redux/services/RoleService/role.Services"
import { ActiveDepartmentList } from "../../redux/services/DepartmentService/deparment.Services"
// import { getDepartmentList } from "../../redux/services/DepartmentService/deparment.Services"
import { successToast, errorToast } from "../../Utils/toast";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import { FaPlus } from "react-icons/fa";

// const permissionsList = [
//     { label: "Lead", key: "lead" },
//     { label: "New", key: "newlead" },
//     { label: "Pending", key: "pendinglead" },
//     { label: "Other ", key: "alllead" },




//     { label: "Lead Assigned", key: "LeadAssigned" },

//     { label: "Task", key: "task" },
//     { label: "Reminder", key: "reminder" },
//     { label: "Meeting", key: "meeting" },

//     { label: "Chat", key: "chat" },

//     { label: "Leave", key: "leave" },

//     { label: "Staff", key: "staff" },
//     { label: "Role", key: "role" },
//     { label: "Staff Activity", key: "StaffActivity" },

//     { label: "Inventory", key: "inventoryManagement" },

//     { label: "Calendar", key: "calendar" },

//     { label: "Settings", key: "settings" },
// ];

const permissionsList = [
    // {
    //     label: "Employees",
    //     key: "employees",
    //     children: [
    //         { label: "Employee", key: "staff" },
    //         { label: "Roles", key: "role" },
    //         { label: "Departments", key: "department" },
    //         { label: "Activity", key: "StaffActivity" },
    //     ],
    // },
    {
        label: "Leads",
        key: "lead",
        children: [
            { label: "New", key: "newlead" },
            { label: "Pending", key: "pendinglead" },
            { label: "Others", key: "alllead" },
            { label: "Assigned Lead", key: "LeadAssigned" },
        ],
    },
    {
        label: "Dashboard",
        key: "dashboard",
    },
    // {
    //     label: "Inventory Management",
    //     key: "inventoryManagement",
    //     children: [
    //         { label: "Categories", key: "category" },
    //         { label: "Sub Categories", key: "subcategory" },

    //     ],
    // },
    // {
    //     label: "Task",
    //     key: "task",
    // },
    // {
    //     label: "Chat",
    //     key: "chat",
    // },
    // {
    //     label: "Reminder",
    //     key: "reminder",
    // },
    // {
    //     label: "Meeting",
    //     key: "meeting",
    // },
    // {
    //     label: "Leave",
    //     key: "leave",
    // },
    // {
    //     label: "Calendar",
    //     key: "calendar",
    // },
    // {
    //     label: "Content / Setting",
    //     key: "settings",
    // },
];

const defaultPermissions = permissionsList.reduce((acc, item) => {
    acc[item.key] = 0;
    if (item.children) {
        item.children.forEach(child => {
            acc[child.key] = 0;
        });
    }
    return acc;
}, {});
function AddStaff({ data, isModal = false }) {
    const dispatch = useDispatch()
    const [errors, setErrors] = useState({});
    const { refreshData } = useSelector((state) => state.staffModal);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
    const [roles, setRoles] = useState([]);
    const [department, setDepartment] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        role: "",
        joining_date: new Date().toISOString().split("T")[0],
        // salary: "",
        department: "",
        department_id: "",
        image: null,
        password: "",
        address: "",
        status: "active",
        permissions: defaultPermissions,
    });

    // INPUT CHANGE
    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: value,
    //     }));
    //     if (errors[name]) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             [name]: null,
    //         }));
    //     }
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            if (name === "department") {
                const selectedDept = department.find((d) => d.name === value);
                return {
                    ...prev,
                    department: value,
                    department_id: selectedDept?.id || "",
                    role: "", // ✅ role reset
                };
            }

            return {
                ...prev,
                [name]: name === "status" ? Number(value) : value,
            };
        });

        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: null,
            }));
        }
    };

    const handleRefresh = () => setRefreshKey(prev => prev + 1);
    const filteredRoles = formData.department_id
        ? roles.filter(
            (role) => Number(role.department_id) === Number(formData.department_id)
        )
        : [];
    // IMAGE
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        setFormData((prev) => ({
            ...prev,
            image: file,
        }));
    };

    const handlePermissionTogglecheck = (key, children = []) => {
        setFormData((prev) => {
            const updatedPermissions = { ...prev.permissions };
            const isChecked = updatedPermissions[key] === 1 ? 0 : 1;

            // If it's a parent with children
            if (children.length > 0) {
                // Toggle parent
                updatedPermissions[key] = isChecked;

                // Toggle all children to match parent
                children.forEach((child) => {
                    updatedPermissions[child.key] = isChecked;
                });
            } else {
                // It's a child - toggle it
                updatedPermissions[key] = isChecked;

                // Find the parent of this child and update it
                const parentItem = permissionsList.find(item =>
                    item.children?.some(child => child.key === key)
                );

                if (parentItem) {
                    // Check if ALL children are checked
                    const allChildrenChecked = parentItem.children.every(
                        child => updatedPermissions[child.key] === 1
                    );

                    // Check if ANY child is checked
                    const anyChildChecked = parentItem.children.some(
                        child => updatedPermissions[child.key] === 1
                    );

                    // If all children are checked, check the parent
                    // If no children are checked, uncheck the parent
                    if (allChildrenChecked) {
                        updatedPermissions[parentItem.key] = 1;
                    } else if (!anyChildChecked) {
                        updatedPermissions[parentItem.key] = 0;
                    }
                }
            }

            return {
                ...prev,
                permissions: updatedPermissions,
            };
        });
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setFormData((prev) => {
            const updatedPermissions = { ...prev.permissions };

            // Update all permissions (both parent and child)
            Object.keys(updatedPermissions).forEach((key) => {
                updatedPermissions[key] = isChecked ? 1 : 0;
            });

            return {
                ...prev,
                permissions: updatedPermissions,
            };
        });
    };

    const isAllSelected = () => {
        return Object.values(formData.permissions).every(val => val === 1);
    };

    const isAnySelected = () => {
        return Object.values(formData.permissions).some(val => val === 1);
    };

    const getParentCheckState = (parentKey) => {
        const parentItem = permissionsList.find(item => item.key === parentKey);
        if (!parentItem?.children) return false;

        const children = parentItem.children;
        const checkedCount = children.filter(
            child => formData.permissions?.[child.key] === 1
        ).length;

        if (checkedCount === 0) return false;
        if (checkedCount === children.length) return true;
        return 'indeterminate';
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = ["Name is required"];
        }
        // if (!formData.salary.trim()) {
        //     newErrors.salary = ["Salary is required"];
        // }
        if (!formData.email.trim()) {
            newErrors.email = ["Email is required"];
        }
        if (!formData.role.trim()) {
            newErrors.role = ["Role is required"];
        }
        if (!formData.department.trim()) {
            newErrors.department = ["Department is required"];
        }
        if (!formData.address.trim()) {
            newErrors.address = ["Address is required"];
        }
        if (!formData.mobile.trim()) {
            newErrors.mobile = ["Mobile is required"];
        }

        setErrors(newErrors);
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setTimeout(() => {
                const firstErrorField = document.querySelector(".is-invalid");
                if (firstErrorField) {
                    firstErrorField.focus();
                    firstErrorField.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
            return;
        }

        try {
            setLoading(true);
            // const submitData = new FormData();
            // submitData.append("name", formData.name);
            // submitData.append("email", formData.email);
            // submitData.append("mobile", formData.mobile);
            // submitData.append("joining_date", formData.joining_date);
            // submitData.append("address", formData.address);
            // submitData.append("role", formData.role);
            // submitData.append("salary", formData.salary);
            // submitData.append("department", formData.department);
            // submitData.append("password", formData.password);
            // submitData.append("status", formData.status);
            // if (formData.image) {
            //     submitData.append("image", formData.image);
            // }
            // Object.keys(formData?.permissions).forEach((key) => {
            //     submitData.append(
            //         `permissions[${key}]`,
            //         formData?.permissions[key]
            //     );
            // });


            const payload = {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                joining_date: formData.joining_date,
                address: formData.address,
                role: formData.role,
                // salary: formData.salary,
                department: formData.department,
                password: formData.password,
                status: formData.status,
                permissions: { ...formData?.permissions },
            };


            const res = await addStaff(payload);

            if (res?.success === true) {
                successToast(res?.message || "Staff created successfully");
                if (refreshData) {
                    refreshData();
                }
                if (isModal) {
                    dispatch(closeStaffModal());
                } else {
                    navigate("/staff-list");
                }
            }
            else {
                // Backend validation error
                if (res?.message && typeof res.message === "object") {
                    const validationErrors = res.message;
                    setErrors(validationErrors);
                    const allErrors = Object.values(validationErrors)
                        .flat()
                        .join(", ");
                    errorToast(allErrors);
                } else {
                    errorToast(
                        res?.message ||
                        res?.errors ||
                        "Something went wrong"
                    );
                }
            }
        }
        // catch (error) {
        //     console.log(error);

        //     if (
        //         error?.response?.data?.message &&
        //         typeof error.response.data.message === "object"
        //     ) {
        //         const validationErrors = error.response.data.message;
        //         setErrors(validationErrors);
        //         const allErrors = Object.values(validationErrors)
        //             .flat()
        //             .join(", ");
        //         errorToast(allErrors);
        //     } else {
        //         errorToast(
        //             error?.response?.data?.errors ||
        //             error?.response?.data?.message ||
        //             "Failed to create staff"
        //         );
        //     }
        // }
        catch (error) {
            console.log(error);
            const response = error?.response?.data;
            if (
                response?.message &&
                typeof response.message === "object"
            ) {
                const validationErrors = response.message;
                setErrors(validationErrors);
                const allErrors = Object.values(validationErrors)
                    .flat()
                    .join(", ");

                errorToast(allErrors);
            } else {
                errorToast(
                    response?.errors ||
                    response?.message ||
                    "Failed to create staff"
                );
            }
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRoles();
        fetchDepartment();
    }, [refreshKey]);

    const fetchRoles = async () => {
        try {
            const response = await allActiveRole();
            setRoles(response?.data || []);
        } catch (error) {
            console.log(error);
            errorToast("Failed to load roles");
        }
    };

    const fetchDepartment = async () => {
        try {
            const response = await ActiveDepartmentList();
            setDepartment(response?.data || []);
        } catch (error) {
            console.log(error);
            errorToast("Failed to load departments");
        }
    };

    return (

        <div className="">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>Add Employee</h4>
                        <button
                            className="add-btn"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>
                    </div>

                    <form onSubmit={handleSubmit} className="row g-3">
                        {/* <div className="col-md-6">
                            <label>Profile Image</label>
                            <input
                                type="file"
                                className="form-control"
                                onChange={handleImageChange}
                            />
                        </div> */}
                        <div className="col-md-6">
                            <label>Name <span className="text-white">*</span></label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.name ? "is-invalid" : ""}`}
                            />
                            {errors?.name && (
                                <div className="invalid-feedback">
                                    {errors.name[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Email <span className="text-light">*</span></label>
                            <input
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`form-control custumform ${errors?.email ? "is-invalid" : ""}`}
                            />
                            {errors?.email && (
                                <div className="invalid-feedback">
                                    {errors.email[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Mobile <span className="text-light">*</span></label>
                            <input
                                name="mobile"
                                value={formData.mobile}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setFormData((prev) => ({
                                        ...prev,
                                        mobile: value,
                                    }));
                                    if (errors.mobile) {
                                        setErrors((prev) => ({
                                            ...prev,
                                            mobile: null,
                                        }));
                                    }
                                }}
                                className={`form-control custumform ${errors?.mobile ? "is-invalid" : ""}`}
                                maxLength={10}
                            />
                            {errors?.mobile && (
                                <div className="invalid-feedback d-block">
                                    {errors.mobile[0]}
                                </div>
                            )}
                        </div>
                        {/* <div className="col-md-6">
                            <label>Salary <span className="text-light">*</span></label>
                            <input
                                name="salary"
                                value={formData.salary}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setFormData((prev) => ({
                                        ...prev,
                                        salary: value,
                                    }));
                                    if (errors.salary) {
                                        setErrors((prev) => ({
                                            ...prev,
                                            salary: null,
                                        }));
                                    }
                                }}
                                className={`form-control custumform ${errors?.salary ? "is-invalid" : ""}`}
                            />
                            {errors?.salary && (
                                <div className="invalid-feedback d-block">
                                    {errors.salary[0]}
                                </div>
                            )}
                        </div> */}
                        <div className="col-md-6">
                            <label>Department <span className="text-light">*</span></label>
                            <div className="d-flex gap-2 align-items-center">
                                <select
                                    name="department_id"
                                    value={formData.department_id}                       // ✅ id bind
                                    onChange={(e) => {
                                        const deptId = e.target.value;
                                        const selectedDept = department.find((d) => String(d.id) === String(deptId));
                                        setFormData((prev) => ({
                                            ...prev,
                                            department_id: deptId,
                                            department: selectedDept?.name || "",              // ✅ name bhi set
                                            role: "",                                          // ✅ role reset
                                        }));
                                        setSelectedDepartmentId(deptId);                     // ✅ modal ke liye
                                        if (errors.department) {
                                            setErrors((prev) => ({ ...prev, department: null }));
                                        }
                                    }}
                                    className={`form-control custumform ${errors?.department ? "is-invalid" : ""}`}
                                >
                                    <option value="">Select Department</option>
                                    {department?.map((dept) => (
                                        <option key={dept.id} value={dept.id}>
                                            {dept.name}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    className="st-action-btn st-view-btn"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                type: "add-department",
                                                title: "Add Department",
                                                data: null,
                                                // refreshData: fetchDepartment,
                                                refreshData: handleRefresh,
                                            })
                                        )
                                    }
                                >
                                    <FaPlus />
                                </button>

                            </div>
                            {errors?.department && (
                                <div className="invalid-feedback d-block">
                                    {errors.department[0]}
                                </div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label>Role <span className="text-light">*</span></label>
                            <div className="d-flex gap-2 align-items-center">
                                <select
                                    name="role"
                                    value={formData.role}
                                    onChange={handleChange}
                                    disabled={!formData.department_id}
                                    className={`form-control custumform ${errors?.role ? "is-invalid" : ""}`}
                                >
                                    <option value="">
                                        {formData.department_id ? "Select Role" : "Select Department first"}
                                    </option>
                                    {filteredRoles?.map((role) => (
                                        <option key={role.id} value={role.name}>
                                            {role.name}
                                        </option>
                                    ))}
                                </select>


                                <button
                                    className="st-action-btn st-view-btn"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                type: "add-role",
                                                title: "Add Role",
                                                // data: null,
                                                data: { department_id: selectedDepartmentId },
                                                //   refreshData: fetchRoles,
                                                refreshData: handleRefresh,
                                            })
                                        )
                                    }
                                >
                                    <FaPlus />
                                </button>
                            </div>
                            {errors?.role && (
                                <div className="invalid-feedback d-block">{errors.role[0]}</div>
                            )}
                        </div>


                        <div className="col-md-6">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* STATUS */}
                        <div className="col-md-6">
                            <label>Status</label>
                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        </div>

                        {/* JOINING DATE */}
                        <div className="col-md-6">
                            <label>Joining Date</label>
                            <input
                                type="date"
                                name="joining_date"
                                value={formData.joining_date}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-12">
                            <label>Address <span className="text-light">*</span></label>
                            <textarea
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                rows="3"
                                className={`form-control custumform ${errors?.address ? "is-invalid" : ""}`}
                            />
                            {errors?.address && (
                                <div className="invalid-feedback d-block">
                                    {errors.address[0]}
                                </div>
                            )}
                        </div>

                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="me-3 mb-0">Permissions</h5>
                                <div className="checkallselectall">
                                    <input
                                        type="checkbox"
                                        id="checkall"
                                        onChange={handleSelectAll}
                                        checked={isAllSelected()}
                                        ref={(el) => {
                                            if (el) {
                                                el.indeterminate = !isAllSelected() && isAnySelected();
                                            }
                                        }}
                                    />
                                    <label htmlFor="checkall" className="ms-1">All Select</label>
                                </div>
                            </div>
                            <div className="row">
                                {permissionsList.map((item) => (
                                    <div key={item.key} className="col-md-4 mb-4">
                                        <div className="card shadow-sm border-0">

                                            {/* Header / Parent Permission */}
                                            <div className="card-header bg-light d-flex align-items-center">
                                                <div className="form-check m-0 w-100">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`perm-${item.key}`}
                                                        checked={formData?.permissions?.[item.key] === 1}
                                                        ref={(el) => {
                                                            if (el && item.children) {
                                                                const state = getParentCheckState(item.key);
                                                                el.indeterminate = state === "indeterminate";
                                                            }
                                                        }}
                                                        onChange={() =>
                                                            handlePermissionTogglecheck(item.key, item.children || [])
                                                        }
                                                    />
                                                    <label
                                                        className="form-check-label fw-bold text-light ms-2"
                                                        htmlFor={`perm-${item.key}`}
                                                    >
                                                        {item.label}
                                                    </label>
                                                </div>
                                            </div>
                                            {item.children?.length > 0 && (
                                                <div className="card-body py-2">
                                                    <div className="ps-2 border-start">
                                                        {item.children.map((child) => (
                                                            <div key={child.key} className="form-check mb-2">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`perm-${child.key}`}
                                                                    checked={formData?.permissions[child.key] === 1}
                                                                    onChange={() =>
                                                                        handlePermissionTogglecheck(child.key, [])
                                                                    }
                                                                />
                                                                <label
                                                                    className="form-check-label text-light ms-2"
                                                                    htmlFor={`perm-${child.key}`}
                                                                >
                                                                    {child.label}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* SUBMIT */}
                        <div className="col-12 text-end">
                            <button
                                type="submit"
                                className="add-btn"
                                disabled={loading}
                            >
                                {loading ? "Creating..." : "Create Employee"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddStaff;